import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';

export interface SalesforceOrganizationTypeTagProps {
    isSandbox?: boolean;
}

export const SalesforceOrganizationTypeTag: React.FC<SalesforceOrganizationTypeTagProps> = (props) => {
	const { isSandbox } = props;

	if (isSandbox === null || isSandbox === undefined) {
		return null;
	}

	return isSandbox ?
		<Tag color='volcano'>{ ADMIN_DASHBOARD_COPY.SANDBOX }</Tag> :
		<Tag color='blue'>{ ADMIN_DASHBOARD_COPY.PRODUCTION }</Tag>;
};

